var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2562,3.1296C11.882,1.1409 9.7042,0 7.2816,0C4.8589,0 2.6811,1.1409 1.3069,3.1296C-0.0605,5.1084 -0.3762,7.6135 0.4607,9.8268C0.6845,10.4312 1.0403,11.0184 1.5157,11.5687L6.8024,17.7784C6.922,17.919 7.0972,18 7.2816,18C7.466,18 7.6411,17.919 7.7607,17.7784L13.046,11.5703C13.5235,11.0169 13.8788,10.4303 14.1008,9.8308C14.9393,7.6135 14.6236,5.1084 13.2562,3.1296ZM12.9222,9.39C12.751,9.8526 12.4716,10.3099 12.0921,10.7498C12.091,10.7509 12.09,10.7519 12.0891,10.7532L7.2816,16.3999L2.4711,10.7497C2.0918,10.3101 1.8123,9.8528 1.6394,9.3858C0.9474,7.5554 1.21,5.4841 2.3423,3.8455C3.478,2.2016 5.2785,1.2587 7.2816,1.2587C9.2846,1.2587 11.0848,2.2015 12.2207,3.8455C13.3531,5.4841 13.616,7.5554 12.9222,9.39Z",
    fill: "#6E6E7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2816,3.7343C5.3383,3.7343 3.7571,5.3152 3.7571,7.2587C3.7571,9.2022 5.3381,10.7832 7.2816,10.7832C9.2251,10.7832 10.806,9.2022 10.806,7.2587C10.806,5.3154 9.2249,3.7343 7.2816,3.7343ZM7.2816,9.5245C6.0322,9.5245 5.0158,8.508 5.0158,7.2587C5.0158,6.0094 6.0322,4.9929 7.2816,4.9929C8.5309,4.9929 9.5473,6.0094 9.5473,7.2587C9.5473,8.508 8.5309,9.5245 7.2816,9.5245Z",
    fill: "#6E6E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaces);
export default __webpack_public_path__ + "static/media/ic_places.6f17c4e2305dad1be49bfdde12c1a028.svg";
export { ForwardRef as ReactComponent };